import GroupedInput from '@/components/forms/GroupedInput';
import { Container } from '@/components/layout/Container';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  padding-top: 40px;
  overflow: hidden;

  ${mediaBreakpointUp('tablet')} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    column-gap: 20px;
  }

  ${mediaBreakpointUp('desktop')} {
    padding-top: 60px;
  }

  ${mediaBreakpointUp('desktopWide')} {
    padding-top: 80px;
  }
`;

export const Heading = styled.h1`
  ${customTextSize(32, 38)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  text-align: center;
  letter-spacing: -0.01em;
  margin-bottom: 30px;

  ${mediaBreakpointUp('desktop')} {
    text-align: left;
    ${customTextSize(49, 58)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    margin-top: 13px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${customTextSize(18, 26)}
  text-align: center;
  margin-bottom: 40px;

  ul {
    list-style: disc;
    text-align: left;
    align-self: center;
    padding-left: ${remCalc(20)};
  }

  > * + * {
    margin-top: 15px;
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(16, 24)}
    margin-bottom: 30px;
  }

  ${mediaBreakpointUp('desktop')} {
    text-align: left;

    ul {
      align-self: flex-start;
    }
  }

  ${mediaBreakpointUp('desktopWide')} {
    ${customTextSize(24, 34)}
  }
`;

export const StyledGroupedInput = styled(GroupedInput)`
  --grouped-input-border-color: ${COLORS.BLUE.LOWLIGHT};
  --button-color: var(--grouped-input-border-color);
  --button-color-hover: ${COLORS.BLUE.BASE};

  width: 100%;
  max-width: 500px;
  margin: 0 auto;

  ${mediaBreakpointUp('desktop')} {
    margin: 0;
  }

  ${mediaBreakpointUp('desktopWide')} {
    max-width: 410px;
  }
`;

export const LeftColumn = styled.div`
  text-align: center;

  ${mediaBreakpointUp('tablet')} {
    grid-column: 2 / -2;
  }

  ${mediaBreakpointUp('desktop')} {
    text-align: left;
    grid-column: 1 / span 6;
  }
`;

export const RightColumn = styled.div`
  position: relative;

  ${mediaBreakpointUp('tablet')} {
    grid-column: 2 / -2;
    width: calc(100% + 40px);
    left: -20px;
  }

  ${mediaBreakpointUp('desktop')} {
    grid-column: 7 / span 6;
    width: 93%;
    left: 7%;
  }
`;

export const ScreenshotWrapper = styled.div`
  position: relative;
`;

export const Screenshot = styled.div`
  width: 100%;
  background-color: ${COLORS.GRAY.HIGHLIGHT};
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 1.10638px 9.95745px 1.65957px rgba(0, 0, 0, 0.14);

  > * {
    width: 100%;
  }
`;

const iconCSS = css`
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 2;
`;

export const PaperPlaneIcon = styled.div`
  ${iconCSS};
  position: relative;
  background-image: url('/staticwebassets/pages/homepage/hero-test-2022-07/homepage_icon_2.svg');
  aspect-ratio: 37 / 20;
  width: 12vw;
  left: 24%;

  ${mediaBreakpointUp('tablet')} {
    width: 11.065625vw;
    margin-bottom: 14px;
  }

  ${mediaBreakpointUp('desktop')} {
    width: 14.9%;
  }
`;

export const ShootingStarIcon = styled.div`
  ${iconCSS};
  position: absolute;
  background-image: url('/staticwebassets/pages/homepage/hero-test-2022-07/homepage_icon_1.svg');
  aspect-ratio: 30.82 / 20.46;
  width: 9.63125vw;
  left: -6.25vw;
  bottom: 0;

  ${mediaBreakpointUp('tablet')} {
    width: 9vw;
    bottom: 2%;
    left: -15%;
  }

  ${mediaBreakpointUp('desktop')} {
    width: 12.2%;
    left: -8.3%;
    bottom: 3%;
  }
`;

export const SmileyIcon = styled.div`
  ${iconCSS};
  position: relative;
  background-image: url('/staticwebassets/pages/homepage/hero-test-2022-07/homepage_icon_4.svg');
  aspect-ratio: 27.04 / 21.4;
  width: 7.5125vw;
  left: 80%;
  margin-top: -2%;

  ${mediaBreakpointUp('tablet')} {
    width: 8vw;
    margin-top: -1%;
  }

  ${mediaBreakpointUp('desktop')} {
    width: 10.65%;
    margin-top: -1.8%;
  }
`;

export const ChatBubbleIcon = styled.div`
  ${iconCSS};
  position: absolute;
  background-image: url('/staticwebassets/pages/homepage/hero-test-2022-07/homepage_icon_5.svg');
  aspect-ratio: 30.83 / 19.97;
  width: 9.634375vw;
  left: 98%;
  top: 25%;

  ${mediaBreakpointUp('tablet')} {
    width: 9vw;
    left: calc(100% + 10px);
  }

  ${mediaBreakpointUp('desktop')} {
    width: 12.2%;
  }
`;

export const EyebrowText = styled.div`
  font-weight: ${FONT_WEIGHTS.BOLD};
  letter-spacing: 0.05rem;
  text-transform: uppercase;
  text-align: inherit;
`;
